export const easeOutQuad = [0.5, 1, 0.89, 1];
